// extracted by mini-css-extract-plugin
export var circle = "_bg-1";
export var exitConfirmationModal = "_bg-5";
export var iframe = "_bg-0";
export var offline = "_bg-3";
export var online = "_bg-2";
export var workstationSelectError = "_bg-4";